<template>
  <div id="preloader" class="fixed w-full h-full z-50 flex items-center justify-center bg-white">
    <div class="flex justify-center items-center w-full h-full">
      <figure class="max-w-28 arrow-anim opacity-0">
        <VectorSingleArrow
          :opacity="100"
          color="ip-color-3"
        />
      </figure>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  isLoading: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['ready']);
const handleLoaded = () => {
  emit('ready');
};

const { $anime } = useNuxtApp();

const animateArrow = () => {
  $anime({
    targets: '.arrow-anim',
    opacity: 1,
    translateY: [300, 0],
    translateX: [-300, 0],
    duration: 500,
    easing: 'easeOutExpo',
  });
};

onMounted(() => {
  nextTick(() => {
    animateArrow();
  });
});

watch(() => props.isLoading,
  val => {
    const to = setTimeout(() => {
      $anime({
        targets: '.arrow-anim',
        scale: 80,
        duration: 500,
        easing: 'easeOutExpo',
        complete: function (anim) {
          clearTimeout(to);
          handleLoaded();
        },
      });
    }, 800);
  },
);
</script>

<style lang="scss">
</style>
